import createPersistedState from "use-persisted-state";

export const useNominations = createPersistedState("nominations");
